export default __webpack_public_path__ + "static/media/hero_card_graph_red@2x.9c1b6a44.png";